import { request } from '@aqx-core/common/request';

import { IGeolocation } from '../modal';

export const geolocationApi = {
  getGeolocation: () => request.get<IGeolocation>('/api/config/v1/geo/location', { timeout: 3000 })
};
